/**
 * Helpers PUROS do índice "Artefatos desta conversa" (`store/artefato.js`,
 * `chat-message.vue`, `chat-indice-artefatos.vue`).
 *
 * A lista em si NÃO é derivada aqui a partir de `messages[].tool_calls` — a
 * decisão de "esta parte vira artefato" é do mixin `renderiza-partes.js`
 * (gates de `$access`, veredito de schema, selo/recibo/falha), e refazê-la
 * fora dele duplicaria a regra. O que mora aqui é só o que cabe numa função
 * sem `this`: montar o registro de UMA bolha a partir do que ela já resolveu,
 * e ordenar a lista pela ordem das mensagens.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 */

/**
 * Os registros que UMA bolha manda para `registrarArtefatoDaConversa`: um por
 * parte resolvida que carrega `artefato` (só o cartão de DADOS o recebe, em
 * `montarCartao`/`montarPreviewDeArtefato` — fallback, selo e recibo nunca).
 *
 * `parteReal` é o que abre o aside — vem na prévia E no cartão inline (o
 * aside é outra forma de ver o mesmo cartão). Fica `null` só em cartão de
 * escrita ou sem painel na superfície (`renderiza-partes.js::abreNoAside`),
 * e aí o índice rola até o `data-artefato-id` do cartão.
 * `mensagemId` é o mesmo `data-mensagem-id` que o trilho carimba na bolha
 * (`messages.vue`), usado só para a ORDEM. `criadoEm` é o `created_at` que o
 * GET /messages devolve por mensagem (`resource_messages.py`); a mensagem
 * viva do turno não o tem, e aí fica `null` — o índice omite o tempo em vez
 * de inventar um.
 */
export function artefatosDaMensagem({ partes, mensagem } = {}) {
  const id = (mensagem && mensagem.id) || null
  const criadoEm = (mensagem && mensagem.created_at) || null
  return (partes || [])
    .filter(function (parte) {
      return Boolean(parte && parte.artefato && parte.identidade)
    })
    .map(function (parte) {
      const artefato = parte.artefato
      return {
        identidade: parte.identidade,
        titulo: artefato.titulo || '',
        icone: artefato.icone || '',
        subtitulo: artefato.subtitulo || '',
        modulo: artefato.modulo || '',
        mensagemId: id,
        criadoEm: criadoEm,
        parteReal: parte.parteReal || null,
      }
    })
}

/**
 * A lista na ordem das MENSAGENS da conversa. O registro chega na ordem em
 * que as bolhas montam (que já é a das mensagens), mas a mensagem viva do
 * turno registra antes de ter id e uma remontagem pode chegar fora de ordem —
 * ancorar em `messages` fecha os dois casos. Artefato cuja mensagem não está
 * na lista (a viva, ainda sem id) fica no FIM, na ordem de registro; a
 * ordenação é estável. Sempre devolve array novo, nunca `undefined`.
 */
export function ordenarArtefatosPelasMensagens(artefatos, mensagens) {
  const lista = artefatos || []
  const posicaoPorId = {}
  ;(mensagens || []).forEach(function (mensagem, indice) {
    if (mensagem && mensagem.id) posicaoPorId[mensagem.id] = indice
  })
  return lista
    .map(function (artefato, indice) {
      const posicao = posicaoPorId[artefato.mensagemId]
      return {
        artefato: artefato,
        posicao: typeof posicao === 'number' ? posicao : Infinity,
        registro: indice,
      }
    })
    .sort(function (a, b) {
      if (a.posicao !== b.posicao) return a.posicao - b.posicao
      return a.registro - b.registro
    })
    .map(function (item) {
      return item.artefato
    })
}
